// Mirrors the schedule mechanism in server/data/rooms.js — keep LAUNCH_DATE in sync with that file.
// Each room's tiers switch from Step 1 to Step 2 automatically once STEP_2_DATE passes, evaluated
// fresh whenever this module runs in the visitor's browser.
const LAUNCH_DATE = new Date('2026-07-20')
const STEP_2_DATE = new Date(LAUNCH_DATE)
STEP_2_DATE.setMonth(STEP_2_DATE.getMonth() + 6)

// The 0.25 (15-min quick-book) tier is a flat convenience fee, not discounted for members and not
// changed by the Step 2 increase — same value in every schedule entry for a given room.
const RATE_SCHEDULES = {
  conference: [
    { effectiveDate: LAUNCH_DATE, public: { 0.25: 15, 1: 40, 2: 75, 4: 135, 8: 215 }, member: { 0.25: 15, 1: 25, 2: 45, 4: 85, 8: 135 } },
    { effectiveDate: STEP_2_DATE, public: { 0.25: 15, 1: 45, 2: 80, 4: 150, 8: 240 }, member: { 0.25: 15, 1: 25, 2: 45, 4: 85, 8: 135 } },
  ],
  'office-107b': [
    { effectiveDate: LAUNCH_DATE, public: { 0.25: 10, 1: 25, 2: 45, 4: 85, 8: 135 }, member: { 0.25: 10, 1: 20, 2: 35, 4: 65, 8: 105 } },
    { effectiveDate: STEP_2_DATE, public: { 0.25: 10, 1: 30, 2: 55, 4: 100, 8: 160 }, member: { 0.25: 10, 1: 20, 2: 35, 4: 65, 8: 105 } },
  ],
  'office-112': [
    { effectiveDate: LAUNCH_DATE, public: { 0.25: 10, 1: 25, 2: 45, 4: 85, 8: 135 }, member: { 0.25: 10, 1: 20, 2: 35, 4: 65, 8: 105 } },
    { effectiveDate: STEP_2_DATE, public: { 0.25: 10, 1: 30, 2: 55, 4: 100, 8: 160 }, member: { 0.25: 10, 1: 20, 2: 35, 4: 65, 8: 105 } },
  ],
}

function tieredPricing(roomId, memberNote) {
  const now = new Date()
  const schedules = RATE_SCHEDULES[roomId]
  const applicable = schedules.filter(s => s.effectiveDate <= now)
  const active = applicable.length ? applicable[applicable.length - 1] : schedules[0]

  const toOptions = tiers =>
    Object.entries(tiers)
      .map(([hours, price]) => ({ hours: Number(hours), price }))
      .sort((a, b) => a.hours - b.hours)
  return {
    public: { type: 'tiered', options: toOptions(active.public) },
    member: { type: 'tiered', options: toOptions(active.member), ...(memberNote ? { note: memberNote } : {}) },
  }
}

export const rooms = [
  {
    id: 'conference',
    name: 'Conference Room',
    type: 'Meeting Room',
    capacity: 8,
    description:
      'A fully equipped conference room ideal for team meetings, client presentations, training sessions, and events.',
    features: [
      'Seats up to 8 people',
      'Large TV monitor',
      'Full whiteboard',
      'Professional podcast lighting',
      'Lectern & podium',
    ],
    images: ['/images/rooms/conference.jpg'],
    pricing: tieredPricing('conference'),
  },
  {
    id: 'office-107b',
    name: 'Part-Time Office 107B',
    type: 'Private Office',
    capacity: 4,
    description:
      'A private, closeable office with professional furnishings — ideal for focused work and small team sessions.',
    features: [
      'Seats up to 4 people',
      'Private & lockable door',
      'Furnished desk & chairs',
      'Quiet, professional setting',
    ],
    images: ['/images/rooms/107b-office.jpg', '/images/rooms/107b-exit.jpg'],
    pricing: tieredPricing('office-107b', 'First hours from monthly pool, then the rates below'),
  },
  {
    id: 'office-112',
    name: 'Part-Time Office 112',
    type: 'Private Office',
    capacity: 4,
    description:
      'A private, closeable office with professional furnishings — perfect for independent professionals and small teams.',
    features: [
      'Seats up to 4 people',
      'Private & lockable door',
      'Furnished desk & chairs',
      'Quiet, professional setting',
    ],
    images: ['/images/rooms/112a-office.jpg'],
    pricing: tieredPricing('office-112', 'First hours from monthly pool, then the rates below'),
  },
]
